import { Card, H4, Icon, IconName, IconSize } from "@blueprintjs/core";
import React from "react";
import { useNavigate } from "react-router-dom";
import { IN_QUEUE_ICON, PROSPECTING_ICON } from "types/appIcons";
import { IN_QUEUE_PATH, PROSPECTING_PATH } from "../RouterApp";
import "./PlatformHomePage.scss";

type AppCardProps = {
    readonly icon: IconName;
    readonly iconClassName?: string;
    readonly title: string;
    readonly description: string;
    readonly to: string;
};

const AppCard: React.FC<AppCardProps> = ({
    icon,
    iconClassName,
    title,
    description,
    to
}) => {
    const navigate = useNavigate();
    return (
        <Card
            className="PlatformHomePage-app-card"
            interactive
            elevation={1}
            onClick={() => navigate(to)}
        >
            <div className="PlatformHomePage-app-card-header">
                <Icon
                    icon={icon}
                    size={IconSize.LARGE}
                    className={iconClassName}
                />
                <H4>{title}</H4>
            </div>
            <p className="PlatformHomePage-app-card-description bp5-running-text">
                {description}
            </p>
        </Card>
    );
};

export const PlatformHomePage: React.FC = () => {
    return (
        <div className="PlatformHomePage-wrapper">
            <div className="PlatformHomePage-content">
                <h2 className="bp5-heading">Welcome to Nira</h2>
                <div className="PlatformHomePage-cards">
                    <AppCard
                        icon={PROSPECTING_ICON}
                        iconClassName="PlatformHomePage-prospecting-icon"
                        title="Prospecting"
                        description="Prospecting is built for developers to greenfield for land with the best interconnection capacity. You can view the costs and capacity at buses and lines across ISOs on an interactive map."
                        to={`/${PROSPECTING_PATH}`}
                    />
                    <AppCard
                        icon={IN_QUEUE_ICON}
                        iconClassName="PlatformHomePage-in-queue-icon"
                        title="In-Queue"
                        description="In-Queue is built for transmission engineers to manage projects going through the interconnection queue. You can get early cost previews before official ISO results and run dropoff scenarios to estimate future costs."
                        to={`/${IN_QUEUE_PATH}`}
                    />
                </div>
            </div>
        </div>
    );
};
